(() => {
  const warmed = new Set();
  const maxWarmups = 4;

  const productLink = (target) => {
    const link = target instanceof Element ? target.closest('a[href]') : null;
    if (!link) return null;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || !url.pathname.startsWith('/products/')) return null;
    url.hash = '';
    return url;
  };

  const warm = (target) => {
    const url = productLink(target);
    if (!url || warmed.has(url.href) || warmed.size >= maxWarmups) return;
    warmed.add(url.href);
    const prefetch = document.createElement('link');
    prefetch.rel = 'prefetch';
    prefetch.as = 'document';
    prefetch.href = url.href;
    document.head.appendChild(prefetch);
  };

  let hoverTimer;
  document.addEventListener('pointerover', (event) => {
    if (event.pointerType === 'touch') return;
    clearTimeout(hoverTimer);
    hoverTimer = setTimeout(() => warm(event.target), 65);
  }, { passive: true });
  document.addEventListener('pointerout', () => clearTimeout(hoverTimer), { passive: true });
  document.addEventListener('touchstart', (event) => warm(event.target), { passive: true, capture: true });
  document.addEventListener('pointerdown', (event) => warm(event.target), { passive: true, capture: true });
  document.addEventListener('focusin', (event) => warm(event.target), { passive: true });
})();
